import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';

interface Props {
  open: boolean;
  onCancel: () => void;
  onSubmit: (note: string) => void;
}

const SubmitNotifyAssistantModal: React.FC<Props> = ({ open, onCancel, onSubmit }) => {
  const [note, setNote] = useState('');

  useEffect(() => {
    if (open) {
      setNote('');
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 800 }}>Submit & Notify Assistant</DialogTitle>
      <DialogContent>
        <Typography
          variant="body2"
          sx={{ mb: 2 }}
        >
          Submitting this document will move it to an approved state, ready for co-signature. A
          notification will be sent to the co-author indicating that changes were made to their
          document.
        </Typography>
        <Typography
          variant="body2"
          sx={{ mb: 1 }}
        >
          Describe your changes to the co-author
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={3}
          maxRows={6}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Your document was edited and submitted. Please review the changes"
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          variant="text"
          onClick={onCancel}
          sx={{ color: '#111927' }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => onSubmit(note.trim())}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitNotifyAssistantModal;
